// 路由前置守卫中间件
// 迁移自 router/index.js : router.beforeEach

export default function ({ route, redirect }) {
  // 原有 beforeEach 逻辑（当前为空 - 仅调用 next()）
  // 如果需要登录守卫，可在此处添加：
  // const token = process.client ? localStorage.getItem('token') : null
  // if (!token && route.name !== 'Login') {
  //   return redirect('/login')
  // }
}
